import {collection, field, identifier, LocalisableEntityData} from "@fedeltapointofsale/data-client";
import {EntityData} from "@fedeltapointofsale/data-client";

export class SellableSizeData extends EntityData<SellableSizeData> {
    @identifier id: number;
    @field label: string;
    @field abbreviation: string;
}

export class SizeGroupData extends EntityData<SizeGroupData> {
    @identifier id: number;
    @field name: string;
    @collection(SellableSizeData) sellableSizes: SellableSizeData[];
}

export class SizeGroupReferenceData extends EntityData<SizeGroupReferenceData> {
    @identifier id: number;
    @field name: string;
}
